const ClientInvoiceFormOptionsArray = [
  { value: null, label: '' },
  { value: 'Third Party Client Invoice Detail', label: 'Detailed US' },
  { value: 'Third Party Client Invoice Detail Intl', label: 'Detailed Belgium' },
  { value: 'Third Party Client Invoice Detail Brazil', label: 'Detailed Brazil' },
  { value: 'Third Party Client Invoice Detail China Chinese', label: 'Detailed China Mandarin' },
  { value: 'Third Party Client Invoice Detail China English', label: 'Detailed China English' },
  { value: 'Third Party Client Invoice Detail India', label: 'Detailed India' },
  { value: 'Third Party Client Invoice Detail Singapore', label: 'Detailed Singapore (multi currency)' },
  {
    value: 'Third Party Client Invoice Detail Singapore single currency',
    label: 'Detailed Singapore (single currency)',
  },
  { value: 'Third Party Client Invoice Summary', label: 'Summary US' },
  { value: 'Third Party Client Invoice Summary Intl', label: 'Summary Belgium' },
  { value: 'Third Party Client Invoice Summary Brazil', label: 'Summary Brazil' },
  { value: 'Third Party Client Invoice Summary China Chinese', label: 'Summary China Mandarin' },
  { value: 'Third Party Client Invoice Summary China English', label: 'Summary China English' },
  { value: 'Third Party Client Invoice Summary India', label: 'Summary India' },
];

export default ClientInvoiceFormOptionsArray;
